import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface IValidTransactionsSummaryMeta{
  processingDate: FormInputMeta,
  bank: FormInputMeta,
  binType: FormInputMeta,
  transactionCode: FormInputMeta,
  
  schema: any,
}

const ValidTransactionsSummaryMeta: IValidTransactionsSummaryMeta = {} as IValidTransactionsSummaryMeta;

ValidTransactionsSummaryMeta.bank = commonFormMeta.bank;
ValidTransactionsSummaryMeta.binType = commonFormMeta.binType;
ValidTransactionsSummaryMeta.transactionCode = commonFormMeta.transactionCode;

ValidTransactionsSummaryMeta.processingDate = {
  label: "Processing Date",
  name: 'processing-date',
  type: 'select',
  options: [
    {
      label: 'Processing date 1',
      value: 'processing-date1',
      selected: true,
    },
    {
      label: 'Processing date 2',
      value: 'processing-date2',
    },
    {
      label: 'Processing date 3',
      value: 'processing-date3',
    },
  ],
  validation: yup.string().required(),
}

const validationSchema: any = {};

for (let fieldname in ValidTransactionsSummaryMeta) {
  validationSchema[fieldname] = (ValidTransactionsSummaryMeta as any)[fieldname].validation;
}

ValidTransactionsSummaryMeta.schema = yup.object().shape(validationSchema);

export default ValidTransactionsSummaryMeta;

